module.exports = __webpack_public_path__ + "img/CW.485393fb.svg";